import { Component, inject, signal } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import {
  BricksIconComponent,
  BricksModalComponent,
  BricksModalHeaderComponent,
  BricksModalBodyComponent,
  BricksModalFooterComponent,
} from '@enbw_bricks/ui'
import { CONTACT_EMAIL } from '../../constants'

@Component({
  selector: 'app-error-message',
  imports: [
    BricksIconComponent,
    BricksModalComponent,
    BricksModalHeaderComponent,
    BricksModalBodyComponent,
    BricksModalFooterComponent,
  ],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.scss',
})
export class ErrorMessageComponent {
  dialog = inject(MatDialog)

  protected readonly contactEmail = signal(CONTACT_EMAIL)

  closeDialog(): void {
    this.dialog.closeAll()
  }
}
